import { Pipe, PipeTransform } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { UserService } from '../../core/services/user.service';
import {
  SMEDisciplineAssignments,
  SMEDisciplineInObservationViewModel,
  SMEDisciplineViewModel,
} from '../models/autogenerated';
import { getObservationToolDisciplineAndSMEAssignedObservable } from '../utils/observation-tool-utils';
import { ExceptionsService } from 'src/app/core/services/exceptions.service';

@Pipe({
  standalone: false,
  name: 'smeDisciplineChipTooltip',
})
export class SMEDisciplineChipTooltipPipe implements PipeTransform {
  constructor(
    private userDataService: UserDataService,
    private userService: UserService,
    private exceptionsService: ExceptionsService,
  ) {}

  transform(
    smeDiscipline: SMEDisciplineViewModel | SMEDisciplineInObservationViewModel
  ): Observable<string> {
    if (!smeDiscipline) {
      return of('');
    }
    const primarySMEUserId = smeDiscipline.assignments?.find(
        (x) => x.label === SMEDisciplineAssignments.PrimarySME
      )?.userId;

    if (
      this.userService.isDAEngineer() &&
      smeDiscipline instanceof SMEDisciplineInObservationViewModel
    ) {
      return getObservationToolDisciplineAndSMEAssignedObservable(
        smeDiscipline,
        this.userDataService,
      ).pipe(
        map((result) => {
          const isUserException = this.exceptionsService.hasUserExceptionAccess(primarySMEUserId) ?'*':'';
          return `${result} ${isUserException}`;
        })
      );
    }

    return of(smeDiscipline.name);
  }
}
